<style lang="scss" src='./ProductsGrid.scss' scoped></style>
<template src="./ProductsGrid.html"></template>

<script>
  import {
    mapState,
    mapActions,
    mapMutations
  } from "vuex";
  import Product from '@/components/product/Product'
  export default {
    name: 'ProductsGrid',
    props: {
      title: '',
      category_id: null,
      show_all_link: false,
      products: [],
    },
    components: {
      Product
    },
    data() {
      return { };
    },
    computed: {},

    methods: {},
    beforeCreate() {},
    created() {},
    mounted() {},
    beforeDestroy() {},
  };

</script>
